import { render, staticRenderFns } from "./CoreCredits.vue?vue&type=template&id=08a86a57"
import script from "./CoreCredits.vue?vue&type=script&lang=js"
export * from "./CoreCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports